import { checkResolution } from "Functions/helpers"
import { updateLazy } from "Functions/lazy"
import { scrollToEl } from "Functions/anchor"
import "Layouts/default"

import './articles-jquery'

const attachPaginatorEvents = () => {
    for (const pagerButton of document.querySelectorAll('.pager__list .c-btn')) {
        if (pagerButton.classList.contains('is-active')) continue

        pagerButton.addEventListener('click', (event) => {
            scrollToEl(document.querySelector('.l-articles__body'), (checkResolution('cxs;xs') ? 0 : 40))
        })
    }
}

$(window).on('popstate', () => {
    setTimeout(() => {
        scrollToEl(document.querySelector('.l-articles__body'), (checkResolution('cxs;xs') ? 0 : 40))
    }, 10);
});

attachPaginatorEvents()

rEvent.on('Listing.fetchedData', () => {
    updateLazy()
    attachPaginatorEvents()
})